import React, {useEffect, useState} from 'react'
import PropTypes from 'prop-types'
import {Box} from '@salesforce/retail-react-app/app/components/shared/ui'
import {useContentSlots} from '../../hooks/use-content-slot'
import CountdownTimer from '../../components/countDownTimer'

const CountDownTimerGlobalContentSlotHtml = ({slotId, context, type, categoryId}) => {
    const {data: slotData, isSuccess} = useContentSlots(slotId, context, type, categoryId)
    const [showTimer, SetShowTimer] = useState(false)

    useEffect(() => {
        if (isSuccess && slotData) {
            const container = document.createElement('div')
            container.innerHTML = slotData
            const el = container.querySelector('.countdown-globle-component')
            if (el) {
                document.body.appendChild(el)
                SetShowTimer(true)
            }
        }
    }, [isSuccess, slotData])

    return <Box>{showTimer && <CountdownTimer />}</Box>
}

CountDownTimerGlobalContentSlotHtml.propTypes = {
    slotId: PropTypes.string.isRequired,
    context: PropTypes.string,
    type: PropTypes.string,
    categoryId: PropTypes.string
}

export default CountDownTimerGlobalContentSlotHtml
